// extracted by mini-css-extract-plugin
export default {"row":"Row-modules__row__LYvp5","rowLeftContent":"Row-modules__rowLeftContent__WWJ1s","rowRightContent":"Row-modules__rowRightContent__N6uCQ"};